export type CategoryKind = 'TECH' | 'BOOK';

// Die Art einer Inventarkategorie wird ausschliesslich im Backend bestimmt
// (InventoryCategoryKindResolver). Hier wird der gelieferte Wert nur geparst,
// damit es keine zweite, driftende Liste von Buch-Kategorien gibt.
// Fehlt der Wert (aelterer Backend-Stand), gilt TECH als Standard.
export function parseCategoryKind(
  raw: string | null | undefined,
): CategoryKind {
  return (raw ?? '').trim().toUpperCase() === 'BOOK' ? 'BOOK' : 'TECH';
}
